var _rect, _path, _path2, _path3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#EDFAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.298 42.0522C53.322 40.7596 54.4716 39.4139 54.8454 38.4395V46.1132H54.8428C54.8428 46.1133 54.8428 46.1135 54.8428 46.1137C54.8428 50.14 45.4759 53.404 33.9214 53.404C22.3668 53.404 13 50.14 13 46.1137C13 46.075 13.0009 46.0363 13.0026 45.9978V38.4395C13.6485 39.3824 14.8538 40.6729 16.7924 41.9266C20.5775 40.0498 26.8384 38.8233 33.9214 38.8233C41.1611 38.8233 47.542 40.1047 51.298 42.0522Z",
    fill: "#BEECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2979 34.3569C53.322 33.0643 54.4715 31.7186 54.8454 30.7441V38.4179H54.8428C54.8428 38.4181 54.8428 38.4183 54.8428 38.4185C54.8428 42.4448 45.4759 45.7088 33.9214 45.7088C22.3668 45.7088 13 42.4448 13 38.4185C13 38.3798 13.0009 38.3411 13.0026 38.3026V30.7441C13.6485 31.6871 14.8539 32.9776 16.7925 34.2314C20.5776 32.3546 26.8385 31.1281 33.9214 31.1281C41.161 31.1281 47.5418 32.4095 51.2979 34.3569Z",
    fill: "#6BD3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5476 26.8726C14.5234 25.58 13.3738 24.2342 13 23.2598V30.9335H13.0026C13.0026 30.9337 13.0026 30.934 13.0026 30.9342C13.0026 34.9606 22.3694 38.2246 33.924 38.2246C45.4785 38.2246 54.8454 34.9606 54.8454 30.9342C54.8454 30.8955 54.8445 30.8569 54.8428 30.8183V23.2598C54.1968 24.2027 52.9914 25.4933 51.0527 26.7471C47.2676 24.8703 41.0068 23.6439 33.924 23.6439C26.6844 23.6439 20.3036 24.9252 16.5476 26.8726Z",
    fill: "#26B0EB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.9214,
    cy: 23.2591,
    rx: 20.9214,
    ry: 7.29036,
    fill: "#6BD3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.6046581cab55bc30fd9791474960769d.svg";
export { ForwardRef as ReactComponent };